<p-dialog appDialogoPadrao="pi pi-pencil" descricao="Nome, ícone e disponibilidade do módulo." [visible]="visivel()" (visibleChange)="visivel.set($event)" [dismissableMask]="true" header="Editar módulo" [style]="{ width: '460px', maxWidth: '95vw' }">
    <form [formGroup]="form" class="flex flex-col gap-4 pt-2">
        <div class="flex flex-col gap-1">
            <label for="md-nome" class="text-sm font-semibold">Nome <span class="text-red-500">*</span></label>
            <input id="md-nome" pInputText type="text" formControlName="nmModulo" maxlength="50" placeholder="Ex.: Intranet CRM" />
            @if (form.controls.nmModulo.invalid && form.controls.nmModulo.touched) {
                <small class="text-red-500">Informe o nome (até 50 caracteres).</small>
            }
        </div>

        <div class="flex flex-col gap-1">
            <label for="md-desc" class="text-sm font-semibold">Descrição <span class="text-red-500">*</span></label>
            <input id="md-desc" pInputText type="text" formControlName="dsModulo" maxlength="250" placeholder="Breve descrição do módulo" />
            @if (form.controls.dsModulo.invalid && form.controls.dsModulo.touched) {
                <small class="text-red-500">Informe a descrição (até 250 caracteres).</small>
            }
        </div>
    </form>

    <ng-template pTemplate="footer">
        <p-button label="Cancelar" [text]="true" (onClick)="fechar()" />
        <p-button label="Salvar" icon="pi pi-check" [disabled]="form.invalid || salvando()" [loading]="salvando()" (onClick)="salvar()" [appCan]="roleModulosEditar" />
    </ng-template>
</p-dialog>
